import Button from '@material-ui/core/Button';
import CardContent from '@material-ui/core/CardContent';
import Paper from '@material-ui/core/Paper';
import React from 'react';
import styled from 'styled-components';
import Picture from '../image/CloudFrontPicture';

import Divider from '../styles/HorizontalDivider';

const SewpatCard = ({ sewpat, handleLearnMore, handleDesignSelect }) => {
    const GridContainer = styled.ul`
        display: grid;
        grid-template-columns: 0.5em minmax(75px,25vw) 0.5em auto;
        grid-template-rows: minmax(3em, 1fr) auto auto;
        max-width: 34em;
        padding: 0;
        
        & li {
          list-style-type: none;
        }

        & li:nth-child(1) {
          grid-row: 1 / span 2;
          grid-column: 2;
          z-index: 2;
        }

        & li:nth-child(2) {
          grid-row: 2 / 4;
          grid-column: 1 / span 4;
          z-index: 1;
        }

        & li:nth-child(3) {
          grid-row: 2 / 3;
          grid-column: 4;
          z-index: 1;
        }

        & li:nth-child(4) {
          grid-row: 3;
          grid-column: 1 / 5;
          z-index: 1;
        }
        
        & .sewpat-card-layout {
          height: 100%;
        }
        
        & .schnoffle-button-small {
          ${props => props.theme.typography.button};
          padding: 0.5em 0.6em;
          min-width: 72px;
          font-size: 0.8125rem;
          min-height: 2em;
          color: white;
        }
        
        & .schnoffle-button-small-flat {
          color: #444;
          margin-right: 1em;
        }
    `;

    const CardSewpatImage = styled.div`
        & img {
          max-height: 32em;
        }
    `;

    const CardHeading = styled.div`
        font-size: ${props => props.theme.fontSizes[9]};
        font-family: ${props => props.theme.serif};
    `;

    const SewpatDescription = styled.div`
        line-height: 1.4;
    `;

    const Actions = styled.div`
        padding: 0.5em 0.75em;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    `;

    const onLearnMore = () => handleLearnMore(sewpat.id);
    const onSelectDesign = () => handleDesignSelect(sewpat.id);

    return (
        <GridContainer>
            <li>
                <CardSewpatImage>
                    <Picture
                        altText='Figürliches Bild vom Schnittmuster'
                        webp={sewpat['figuri-clipped'].webp}
                        src={sewpat['figuri-clipped'].src}
                        png
                        schnoffle
                        path={`schnittmuster/${sewpat.id}`}
                    />
                </CardSewpatImage>
            </li>
            <li>
                <Paper elevation={1} className='sewpat-card-layout'>
                    &nbsp;
                </Paper>
            </li>
            <li>
                <CardContent className={'sewpat-card-content'}>
                    <CardHeading>{sewpat.title}</CardHeading>
                    <Divider margin='1em 0 0.75em' />
                    <SewpatDescription>
                        {sewpat.summary.content}
                    </SewpatDescription>
                </CardContent>
            </li>
            <li>
                <Divider margin='0.15em 0.5em' />
                <Actions>
                    <Button
                        size='small' color='secondary'
                        classes={{ sizeSmall: 'schnoffle-button-small schnoffle-button-small-flat' }}
                        onClick={onLearnMore}
                    >
                        mehr Info's
                    </Button>
                    <Button
                        variant='contained' size='small' color='secondary'
                        classes={{ sizeSmall: 'schnoffle-button-small' }}
                        onClick={onSelectDesign}
                    >
                        Stoff wählen
                    </Button>
                </Actions>
            </li>
        </GridContainer>

    );
};

export default SewpatCard;



// WEBPACK FOOTER //
// ./src/components/sewpat/SewpatCard.js